import React from "react";

const ChecklistHeader = () => (
  <header>
    <a href="/" alt="Home">
      <img src="/assets/main_logo.svg" width="320" height="88" alt="Today's Clinical Lab Logo" />
    </a>
    <h1>Email Promotion Checklist</h1>
  </header>
);

export default ChecklistHeader;
